export const AdminBoardCategoryController = {
    index(): void {},
    store(): void {},
    reorder(): void {},
    update(): void {},
    destroy(): void {},
};
